import React, { Component } from 'react';
import Select from 'react-select';
import ShareInput from './ShareInput';
import { shareBoard } from '../../../services/api/api';

import '../../../style/Common.css';
import '../../../style/Header.css';

const selectStyles = {
  control: baseStyles => ({
    ...baseStyles,
    backgroundColor: 'transparent',
    border: 'none !important',
    boxShadow: 'none !important',
    borderRadius: '10px',
    cursor: 'pointer',
    width: '100px'
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  input: baseStyles => ({ ...baseStyles, width: '80px' }),
  menu: baseStyles => ({
    ...baseStyles,
    backgroundColor: '#444049',
    borderRadius: '10px'
  }),
  singleValue: baseStyles => ({ ...baseStyles, color: '#fff' }),
  option: (baseStyles, { isSelected }) => ({
    ...baseStyles,
    color: '#fff',
    cursor: 'pointer',
    backgroundColor: isSelected ? '#FF519A' : '#444049',

    '&:hover': { backgroundColor: '#a9a9a9' }
  })
};

const roleOptions = [
  { value: 'owner', label: 'Owner', key: 'owner' },
  { value: 'editor', label: 'Editor', key: 'editor' },
  { value: 'viewer', label: 'Viewer', key: 'viewer' }
];

export default class AddUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemList: [],
      selectedRole: 'editor',
      selectedRoleOption: { value: 'editor', label: 'Editor' },
      error: false
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.renderBlocks = this.renderBlocks.bind(this);
    this.removeBlock = this.removeBlock.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.setSelectedRole = this.setSelectedRole.bind(this);
    this.handleShareBtn = this.handleShareBtn.bind(this);
  }
  validateEmail(email) {
    const EMAIL_REGEX = /(.+)@(.+){2,}\.(.+){2,}/;

    return EMAIL_REGEX.test(email);
  }

  handleClick() {
    if (this.state.error === true) {
      return this.setState({ error: false });
    }
    return;
  }

  handleKeyPress(value) {
    const oldList = this.state.itemList;
    const isValid = this.validateEmail(value);

    const newEmailList = oldList.concat({ email: value, isValid });

    this.setState({ itemList: newEmailList });
  }

  removeBlock(e, email) {
    e.preventDefault();
    const index = this.state.itemList.indexOf(email);
    const list = this.state.itemList;
    list.splice(index, 1);

    return this.setState({ itemList: list });
  }

  renderBlocks() {
    if (this.state.itemList.length === 0) {
      return;
    }

    return this.state.itemList.map(item => (
      <span
        className={`emailBlock ${item.isValid ? 'valid' : 'invalid'}`}
        key={`emailBlock_${item.email}`}
      >
        {item.email}
        <button className="emailBlock-remove-btn" onClick={e => this.removeBlock(e, item)}></button>
      </span>
    ));
  }

  setSelectedRole(selectedOption) {
    this.setState({ selectedRole: selectedOption.value, selectedRoleOption: selectedOption });
  }

  async handleShareBtn() {
    if (this.state.itemList.length === 0) {
      return this.setState({ error: true });
    }

    const validEmails = this.state.itemList.filter(item => item.isValid).map(item => item.email);

    if (validEmails.length === 0) {
      return this.setState({ error: true });
    }

    const boardId = window.location.pathname.split('/')[2];
    const newPermissions = await shareBoard({
      emails: validEmails,
      role: this.state.selectedRole.toLowerCase(),
      boardId
    });
    this.props.setPermissions(newPermissions);
    this.setState({ itemList: [] });
  }

  render() {
    const { selectedRole, error } = this.state;
    const errorClasses = `error text-left ${error === true ? 'visible' : 'hidden'}`;
    const addEmailSectionClasses = `add-email-section ${
      this.props.publicLink === true ? 'add-email-section-hidden' : 'add-email-section-visible'
    }`;
    const roleSectionClasses = `role-section ${
      this.props.publicLink === true ? 'role-section-hidden' : 'role-section-visible'
    }`;
    //settings editors can set permissions
    return (
      <>
        <h3 className="m-b-1">Share this board with people</h3>
        <div className="d-flex">
          <div className={addEmailSectionClasses}>
            {this.renderBlocks()}
            <ShareInput
              handleKeyPress={this.handleKeyPress}
              handleClick={this.handleClick}
              clear={this.state.clear}
            />
          </div>
          <div className={roleSectionClasses}>
            <Select
              options={roleOptions}
              value={this.state.selectedRoleOption}
              onChange={this.setSelectedRole}
              styles={selectStyles}
              className="role-selector"
            />
          </div>
        </div>
        <div className={errorClasses}>Please enter a working email address to share.</div>
        <div className="m-t-2 m-b-2 text-right">
          <button className="btn btn-primary" onClick={this.handleShareBtn}>
            Share
          </button>
        </div>
      </>
    );
  }
}
